<template>
	<div class="content">
		<van-nav-bar title="选购类型"/>
		 <van-swipe :autoplay="3000">
			<van-swipe-item v-for="(item, index) in images" :key="index">
		   			<el-image style="width: 100%; height: 200px" :src="item.headPhoto"></el-image>
  			</van-swipe-item>
		</van-swipe>
		<van-loading type="spinner" class='loading' color="#1989fa" />
		    <van-row >
		  	 	<van-col span="24">
				  	<van-col offset="2" span="20" style=" margin-bottom: 20px;margin-top: 20px;" >
					  <!-- <van-button   type="info" block  @click="sk()" class="">散客票</van-button>-->
					    <van-button   type="info" block  @click="sk()" class="">门票预约</van-button>
					</van-col>
			    <!--	<van-col  offset="2" span="20" >
					   <van-button  type="info" block @click="tt()" class="">团体票</van-button>
					</van-col>-->
			     </van-col>
			    
           </van-row>
	    <van-tabbar v-model="active">
		    <van-tabbar-item icon="home-o" @click="home()">购票首页</van-tabbar-item>
			<van-tabbar-item icon="setting-o"  @click="user()">个人中心</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
  export default {
  data () {
    return {
    	  hide:false,
    	  images: [],
	      phone:'',
   	      active: 0,
		  text: '',
	      message:'',
	      code:'',
	      show: false,
	      endshow: false,
		  isLoadingShow: true,
	      className: '',
	      endclassName:''
	    }
    },
    mounted() {
    	this.userlista();
    	this.imageslist();
    },
    methods: {
		sk(){
		   this.$router.push({ path: "/mn_ticketList"});
		},
		tt(){
		  
		      this.$router.push({ path: "/mn_ticketGroup"});
		    
		},	
	    home(){
	    	 this.$router.push({ path: "/mn_ticketIndex" });
	    },
	    user(){
	       //window.location.href = '/wx_ticketUser';
	    	 this.$router.push({ path: "/mn_ticketUser"});
	    },
	    	
    	userlista(){
    		let storage=window.sessionStorage;
    		let openida = storage.getItem("openid");
    	  
    		if(openida == null || openida == "null" || openida == "undefined" || openida == undefined || openida== "" ){
    		   this.$axios({
						url: "/api/wechat/findWXUser",
						method: "get",
						params: {}
					})
				.then(res => {
				    let data = res.data;
					if(data.length>0){
					    let open_id = data[0].openid;
					    //let open_id = "123123123123123123";
				        storage.setItem("openid",open_id);
				     }else{
				     	
				     	 
					   alert("openID获取失败，请退出小程序在进入购票中心");
					 
					  
			      }
			  })
				.catch(err => {
					console.log(err);
				   });
	    		}else{
	    			
	    			console.log("11111111111")
	    		}
    	},
	  
        imageslist(){
    	    let scenicAreaID = "";
			this.$axios({
					url: "/api/wechatPublicConfig/carouselList",
					method: "get",
					params: {
						pageItems: 999, //每页显示的条数
						pageNumber: 1, //页数
						scenicAreaID: scenicAreaID,
					}
				})
			.then(res => {
				 var data = res.data[0];
				  this.images = [];
			
			    for (const i in data) {
		         var headPhoto = "";
		        if (data[i].imagePath) {
		           headPhoto = "/api/image?url=" + data[i].imagePath;
		           
		        }
		        this.images.push({
		        	 headPhoto
		         });
		       
		         
		      }
			 })
				.catch(err => {
				console.log(err);
			});
		},
			
	    showPopup () {
	      this.show = true
	      this.isLoadingShow = true
	      setTimeout(() => {
	        this.isLoadingShow = false
	      }, 500)
	    },
	    endshowPopup () {
	      this.endshow = true
	      this.isLoadingShow = true
	      setTimeout(() => {
	        this.isLoadingShow = false
	      }, 500)
	    },
  
    }
  
}
</script>

<style scoped>
 .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
  }
  img{
  	width: 100%;
  	height: 200px;
  }
	.icon_color1 i {
		color:#1989fa;
	}
	.icon_color2 i {
		color:#19c160;
	}
	.icon_color3 i {
		color:#07c160;
	}
	.icon_color4 i {
		color:#4fc08d;
	}
	.icon_color5 i {
		color:#2989fa;
	}
	.content{
		width: 100%;
		height: 100%;
		background-color: #FFFFFF;
	}
	.box{
		width: 90%;
		margin-top: 20px;
		margin-left: 5%;
		background-color: #97CBFF;
	}
	.box_header{
		height: 40px;
		line-height: 40px;
		color: #000000;
		font-size: 15px;
		font-weight: 600;
		text-align: center;
		background-color: #F0EFED;
	}
	
	
	.router{
		color: #646566;
	}
	.activerouter{
		color: #1989fa;
	}
	.loading{
		display: none;
	}
</style>


// WEBPACK FOOTER //
// src/system/index/wechatlistmini/mn_ticketIndex.vue